import React from 'react';
import { useSelector } from 'react-redux';

import AccessDenied from './AccessDenied';

const SecuredView = ({ role, children, returnNull }) => {
  const roles = useSelector(state => state.Auth?.user?.roles ?? []);

  if (!roles.includes(role)) {
    if (returnNull === true) {
      return <></>;
    }
    return <AccessDenied />;
  }

  return <>{children}</>;
};

export default SecuredView;
